document.addEventListener('DOMContentLoaded', function () {
  var els = document.querySelectorAll('.air-reveal, .air-reveal-group');

  if (!('IntersectionObserver' in window)) {
    return;
  }

  els.forEach(function (el) { el.classList.add('air-reveal-armed'); });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });

  // Stagger children of reveal groups (icon rows, product grids, testimonial grids)
  document.querySelectorAll('.air-reveal-group').forEach(function (group) {
    var children = group.children;
    for (var i = 0; i < children.length; i++) {
      children[i].style.transitionDelay = (i * 70) + 'ms';
    }
  });
});
